module.exports = __webpack_public_path__ + "img/コンピュータのしくみI_4_20_1.957c6062.jpeg";